async function recommendationMealsAPI() {
  const resolve = await fetch('https://www.themealdb.com/api/json/v1/1/search.php?s=');
  const data = await resolve.json();
  return data.meals;
}

export default recommendationMealsAPI;
